<script setup lang="ts">
import SparklineValuesDTO = Modules.BookingExperts.Data.SparklineValuesDTO;
import { useApiClient } from "@/api/client";
import { ref, watch, onBeforeMount } from "vue";
import { formatNumber } from "chartjs-graph";
import { useHomeStore } from "@/modules/home/store";

const store = useHomeStore();

const sparklineTaskValues = ref<SparklineValuesDTO | undefined>();

watch(() => store.daysToLookBack, getSparklineValues);
onBeforeMount(getSparklineValues);

async function getSparklineValues() {
	const taskResponse = await useApiClient("proLoyalty").getSparklineValues(
		"task",
		{ daysToLookBack: store.daysToLookBack }
	);
	if (taskResponse.isOk()) {
		sparklineTaskValues.value = taskResponse.value;
	}
}
</script>

<template>
	<v-card class="home-graph-card">
		<v-card-title class="bg-background" style="height: 48px">
			Tasks
		</v-card-title>

		<div
			v-if="sparklineTaskValues"
			class="d-flex flex-column justify-space-between"
		>
			<div class="pa-3">
				<div class="d-flex align-center">
					<v-chip
						variant="tonal"
						color="secondary-tonal"
						size="large"
						style="font-size: 28px; font-weight: 500"
					>
						{{ formatNumber(sparklineTaskValues?.sum) }}
					</v-chip>
					<span class="ml-2">Created in Bex</span>
					<v-spacer />
					<v-avatar color="secondary-tonal" variant="tonal" class="rounded-md">
						<v-icon size="22">fa: fa-light fa-list-check</v-icon>
					</v-avatar>
				</div>
			</div>
			<div>
				<v-sparkline
					:model-value="sparklineTaskValues.values"
					:gradient="['rgba(84, 110, 122, 0.05)', 'rgba(84, 110, 122, 0.2)']"
					color="#546E7A"
					height="100"
					stroke-linecap="round"
					line-width="2"
					fill
					smooth
					type="trend"
					:show-labels="false"
					padding="0"
				>
				</v-sparkline>
			</div>
		</div>
	</v-card>
</template>

<style scoped lang="scss">
.home-graph-card {
	display: grid;
	grid-template-rows: auto 1fr;
}
</style>
